import PropTypes from 'prop-types';

const SubtitleLink = ({ geographicalNode, useDivider }) => {
  const nodeDivider = useDivider ? ', ' : '';

  if (!geographicalNode) {
    return null;
  }

  if (geographicalNode.url) {
    return (
      <a href={geographicalNode.url}>
        {geographicalNode.name}
        {nodeDivider}
      </a>
    );
  }

  return (
    <span>
      {geographicalNode.name}
      {nodeDivider}
    </span>
  );
};

SubtitleLink.propTypes = {
  geographicalNode: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
  }),
  useDivider: PropTypes.bool,
};

SubtitleLink.defaultProps = {
  useDivider: false,
  geographicalNode: null,
};

export default SubtitleLink;
